import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  InputAdornment,
  Alert,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import CreateTagModal from "./CreateTagModal";
import EditTagModal from "./EditTagModal";
import DeleteTagModal from "./DeleteTagModal";

const ManageTagsModal = ({
  open,
  handleClose,
  tagOptions = [],
  onRefresh = () => {},
}) => {
  const [tags, setTags] = useState(tagOptions || []);
  const [selectedTag, setSelectedTag] = useState(null);
  
  const [searchTerm, setSearchTerm] = useState("");

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  

  useEffect(() => {
    setTags(tagOptions);
  }, [tagOptions]);

  const openEditModal = (tag) => {
    setSelectedTag(tag);
    setShowEditModal(true);
  };

  const openDeleteModal = (tag) => {
    setSelectedTag(tag);
    setShowDeleteModal(true);
  };

  const filteredTags = tags.filter((tag) =>
    tag.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      sx={{ zIndex: 1202 }}
      fullWidth
    >
      {/* Header */}
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          Manage Tags
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent dividers>
        {/* Toolbar */}
        <Box mb={3} display="flex" gap={2} alignItems="center">
          <TextField
            fullWidth
            size="small"
            placeholder="Search tags..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              setShowCreateModal(true);
            }}
            sx={{ whiteSpace: "nowrap" }}
          >
            Create Tag
          </Button>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Tag Name</TableCell>
                <TableCell>Audience</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTags.map((tag) => (
                <TableRow key={tag.id} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={500}>
                      {tag.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{tag.audienceCount}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => openEditModal(tag)}
                      color="primary"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => openDeleteModal(tag)}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {filteredTags.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Typography variant="body2" color="text.secondary" py={2}>
                      No tags found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      {/* Footer */}
      <DialogActions>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          px={2}
        >
          <Typography variant="body2" color="text.secondary">
            Total: {tags.length} tag(s)
          </Typography>
          <Button onClick={handleClose}>
            Close
          </Button>
        </Box>
      </DialogActions>

      {/* Create Modal */}
      <CreateTagModal
        open={showCreateModal}
        handleClose={() => {
          if(onRefresh) onRefresh();
          setShowCreateModal(false);
        }}
      />

      {/* Edit Modal */}
      <EditTagModal
        open={showEditModal}
        handleClose={() => {
          if(onRefresh) onRefresh();
          setShowEditModal(false);
        }}
        selectedTag={selectedTag}
      />

      {/* Delete Modal */}
      <DeleteTagModal
        open={showDeleteModal}
        handleClose={() => {
          if(onRefresh) onRefresh();
          setShowDeleteModal(false);
        }}
        selectedTag={selectedTag}
      />
    </Dialog>
  );
};

export default ManageTagsModal;
